import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import cn from 'classnames/bind'

import PlainInput, { PlainInputProps, Ref } from './plain-input'

import styles from './plain-input-number.module.scss';


const cx = cn.bind(styles)

type Props = {
  hideArrows?: boolean
} & PlainInputProps

export const PlainInputNumberStateful = ({
  hideArrows,
  inputClassName,
  defaultValue,
  onChange,
  value,
  loading,
  ...others
}: Props) => {
  const [currentValue, setCurrentValue] = useState(defaultValue || '0')

  const handleChange = useCallback((e: ChangeEvent<Ref>) => {
    setCurrentValue(e.target.value)
    onChange?.(e)
  }, [onChange])

  useEffect(() => {
    if (value) {
      setCurrentValue(value)
    }
  }, [value, loading])

  useEffect(() => {
    if (defaultValue) {
      setCurrentValue(defaultValue)
    }
  }, [defaultValue])

  return (
    <PlainInput
      type="number"
      inputClassName={cx(inputClassName, { hideArrows })}
      inputmode="numeric"
      {...others}
      value={currentValue}
      onChange={handleChange}
      loading={loading}
      defaultValue={defaultValue}
    />
  )
}
